<span class="flex items-center">
    @switch (status()) {
        @case (ApplicationStatus.Draft) {
            <span class="badge bg-caution-emphasis" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.Submitted) {
            <span class="badge bg-info-emphasis" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.InReview) {
            <span class="badge bg-[var(--element-data-12)]" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.PreAwardCommittee) {
            <span class="badge bg-[var(--element-data-8)]" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.AwardCommittee) {
            <span class="badge bg-[var(--element-data-7)]" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.Approved) {
            <span class="badge bg-success-emphasis" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.Denied) {
            <span class="badge bg-danger-emphasis" aria-hidden="true">&nbsp;</span>
        }
        @case (ApplicationStatus.OnHold) {
            <span class="badge bg-[var(--element-ui-2)]" aria-hidden="true">&nbsp;</span>
        }
        @default {
            <span class="badge bg-secondary" aria-hidden="true"></span>
        }
    }
</span>
